import { map, uniq } from 'lodash';

/**
 * Get an appointment status and status reason
 * @category Getters
 * @category Appointment
 */
export function getStatusAndStatusReason(apptStatusFilter: string[]) {
  // get the appointment status reason e.g confirmed-arrived is just confirmed and uniq to avoid duplicates
  const apptStatus = uniq(
    map(apptStatusFilter, (status) => status.split('-')[0]),
  );
  // get the appointment status reason e.g confirmed-arrived is just arrived
  const apptStatusReason = map(
    apptStatusFilter,
    (status) => status.split('-')[1],
  ).filter(Boolean);

  return [apptStatus, apptStatusReason];
}
